import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueScrollTo from 'vue-scrollto'
import VueRecaptcha from 'vue-recaptcha'
import qs from 'qs'
import _ from 'lodash'
import { confirmLost } from '../animal-status-update'

// Warn user about unsaved changes on navigation away:
function beforeUnload(e) {
  e.preventDefault()
  e.returnValue = ''
}

var lostPetPreviewFormEl = document.getElementById('v-lost-pet-preview-form')
if (lostPetPreviewFormEl) {
  window.addEventListener('beforeunload', beforeUnload)
}

// Animate page scroll:
Vue.use(VueScrollTo)

// For handling API data:
Vue.use(VueAxios, axios)

let path = '/lost-pet/'

export default Vue.component('lost-pet-preview-form', {
  props: ['isUpdate', 'isPublicView', 'context', 'token'],
  components: {
    VueRecaptcha,
  },
  data() {
    let originalData = {}
    Object.assign(originalData, window.CANZ?.listingDetails || {})
    const initialExtraDetails = {
      mobileNumber: originalData?.guardianMobileNumber,
      alternativeNumber: originalData?.guardianAlternativeNumber,
    }
    return {
      listingId: originalData?.listingId,
      companionAnimalId: originalData?.companionAnimalId ?? '',
      loading: false,
      formErrors: [],
      errors: {},
      originalData,
      response: '',
      extraDetailsHidden: !originalData?.showExtraDetails,
      extraDetails: originalData?.showExtraDetails ? initialExtraDetails : {},
      showModal: false,
      socialMediaModal: {
        sharingText: originalData?.socialSharingText ?? '',
        previewLink: originalData?.previewLink ?? '',
        facebookSharingLink: originalData?.facebookSharingLink ?? '',
      },
      // Controls action success/failure messages visibility within modal
      showFailureMessage: false,
      companionAnimalName: originalData?.companionName ?? '',
      canBeSyncedWithNZCAR: originalData?.canBeSyncedWithNZCAR,
      syncWithRego: false,
    }
  },
  mounted() {
    if (this.isPublicView) {
      window.removeEventListener('beforeunload', beforeUnload)
    }
  },
  methods: {
    telLinkFor(number) {
      return `tel:${number}`
    },
    backToEdit(e) {
      e.preventDefault()
      window.removeEventListener('beforeunload', beforeUnload)

      let pathWithContext = path + this.context

      if (this.context == 'lost') {
        window.location = pathWithContext + '/update/' + this.listingId + '?edit=true'
      } else {
        window.location = pathWithContext + '/add/?id=' + this.listingId + '&edit=true'
      }
    },
    doPost(e) {
      e.preventDefault()

      this.formErrors = []
      this.errors = {}
      this.loading = true

      if (!!this.companionAnimalId) {
        confirmLost
          .apply(this, [this.companionAnimalId, this.token])
          .then(() => {
            this.callPublishListing()
          })
          .catch(this.handleErrors)
      } else {
        this.callPublishListing()
      }
    },
    callPublishListing() {
      let pathWithContext = path + this.context
      let url = pathWithContext + '/publish/' + this.listingId

      this.axios({
        method: 'POST',
        url,
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
          listingId: this.listingId,
          isUpdate: this.isUpdate,
          context: this.context,
          updateNZCARRego: this.syncWithRego,
        }),
        maxRedirects: 0,
      })
        .then((response) => {
          if (response?.data?.status === 'success') {
            window.removeEventListener('beforeunload', beforeUnload)
            if (this.context == 'lost') {
              if (this.originalData.showMicrochipPrompt) {
                const searchParams = new URLSearchParams()
                searchParams.set('mc-prompt', true)
                searchParams.set('name', this.originalData.companionName)

                window.location = '/my-companion-animals/lost-pet/?' + searchParams
              } else {
                window.location = '/my-companion-animals/lost-pet/'
              }
            } else {
              window.location = '/LostPet/'
            }
          } else {
            this.handleErrors({ response })
          }
        })
        .catch(this.handleErrors)
    },
    handleErrors(error) {
      this.loading = false
      const errors = {}
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors || {}).forEach((k) => {
          this.formErrors.push(error.response.data.errors[k])
        })
      } else {
        this.formErrors.push({
          value: 'An unknown error has occurred, please try again, or copy your data and reload the page',
        })
      }
      this.errors = errors

      this.$nextTick(() => {
        errorElements = document.getElementsByClassName('c-message--error')

        if (errorElements?.length) {
          VueScrollTo.scrollTo(errorElements[0], 400, {
            offset: -75,
          })
        }
      })
    },
    handleCaptchaSuccess(recaptchaToken) {
      this.response = recaptchaToken

      this.axios({
        method: 'POST',
        url: '/api/extra-listing-details',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
          recaptchaResponse: this.response,
          listingId: this.listingId,
        }),
        maxRedirects: 0,
      })
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.extraDetailsHidden = false
            this.extraDetails = response?.data?.data
          } else {
            this.handleErrors(response)
            self.$refs.recaptcha.reset()
          }
        })
        .catch(this.handleErrors)
    },
    handleCaptchaError() {
      console.log('recaptcha error')
    },
    onCaptchaExpired() {
      // Only show checkbox again if not already verified
      if (this.extraDetailsHidden) {
        this.response = ''
      }
    },
    showSocialMediaModal() {
      this.showModal = true
    },
    copyTemplateText(e) {
      let copyText = document.getElementById('template-text')

      // This will not work locally, needs to be tested on dev site
      navigator.clipboard.writeText(copyText.innerText).then(() => {
        document.getElementById('copy-text-button').innerText = 'Copied!'
      })
    },
    onModalClose() {
      this.showModal = false
      this.errors = {}
      this.showFailureMessage = false
      this.errorMessage = ''
    },
  },
})
